module.exports = __webpack_public_path__ + "static/media/2073333.b6339c96.png";